import { getExtraStepsLand } from './getExtraStepsLand';
import { getExtraSteps } from './getExtraSteps';
import { EGeoSearchTypes } from '../constants';
import { EObjectType } from '../../../repositories/demand/v4/create-message';

export const getExtraStepsByType = (objectType: string, searchType: EGeoSearchTypes) => {
  return objectType === EObjectType.Land || objectType === EObjectType.CommercialLand
    ? getExtraStepsLand(searchType)
    : getExtraSteps(searchType);
};
